import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, autorun} from 'mobx';
import * as d3 from 'd3';
import {getInnerRadius} from './studioUtility';

@inject('studioStore')
@observer
class StudioPlayerTrackGrid extends Component {
    componentDidMount() {
        const {studioStore} = this.props;
        autorun(() => {
            this.setPathD(studioStore.beatCount, studioStore.timeSignatureMeter, studioStore.numBeatsPerBar, studioStore.gridDivision, studioStore.advancedMode);
        });
    }

    getGridLines = (beatCount, timeSignatureMeter, numBeatsPerBar, gridDivision, advancedMode) => {
        let d3G = d3.select(this.G);
        let x1 = 0;
        let y1 = -getInnerRadius(0); // tracks section start
        let x2 = 0;
        let y2 = -getInnerRadius(7); // tracks section end

        // gridDivision = 1;
        // beatCount *= gridDivision;
        let barCount = beatCount / (numBeatsPerBar * gridDivision);
        // console.log('beatCount: ', beatCount, ' timeSigMeter: ', timeSignatureMeter, ' numBeatsPerBar: ', numBeatsPerBar, ' grid Division: ' , gridDivision);
        let detailedView = advancedMode;
        if (this.props.mobileView) {
            detailedView = false;
        }

        d3G.selectAll('*').remove();
        for (let i = 0; i < beatCount; i += 1) {
            if (detailedView) {
                d3G.append('line')
                    .attr('x1', x1)
                    .attr('y1', y1)
                    .attr('x2', x2)
                    .attr('y2', y2 + (i % (numBeatsPerBar * gridDivision) === 0 ? -14 : 0))
                    .attr('class', `studio-grid-lines ${i % (numBeatsPerBar * gridDivision) === 0 ? ' studio-grid-mark-line' : ''}`)
                    .attr('transform', `rotate(${360 / beatCount * i})`);
            }

            const x = 360 * Math.sin((i / (numBeatsPerBar * gridDivision)) / (barCount / 360) * (Math.PI / 180));
            const y = -360 * Math.cos((i / (numBeatsPerBar * gridDivision)) / (barCount / 360) * (Math.PI / 180)) + (numBeatsPerBar);

            if (i % (numBeatsPerBar * gridDivision) === 0 && (barCount <= 100 || (barCount > 100 && i / numBeatsPerBar % 2 === 0))) {
                if (!detailedView) {
                    d3G.append('circle')
                        .attr('cx', x)
                        .attr('cy', y)
                        .attr('fill', '#d8d8d8')
                        .attr('r', 6);
                } else {
                    d3G.append('text')
                        .attr('class', 'studio-track-bar-mark-title')
                        .attr('text-anchor', 'middle')
                        .attr('font-size', 12)
                        .attr('x', x)
                        .attr('y', y)
                        .text((i / (numBeatsPerBar * gridDivision)) + 1);
                }
            }
        }
    };

    @action setPathD = (beatCount, timeSignatureMeter, numBeatsPerBar, gridDivision, advancedMode) => {
        this.getGridLines(beatCount, timeSignatureMeter, numBeatsPerBar, gridDivision, advancedMode);
    };

    setRef = (g) => {
        this.G = g;
    };

    render() {
        // const {fillColor} = this.props;
        return <g ref={this.setRef}/>;
    }
}

export default StudioPlayerTrackGrid;
